import { createWizard } from 'clientside/wizard';
import 'protons';
import './_wizard-vacancies.twig';
import template from './template.vue';

export const name = 'wizard-vacancies';

export const defaults = {};

export function disable() {}

export function enable(context) {
  const el = context.querySelector('#wizard-vacancies');
  if (!el) return;

  const elConfig = JSON.parse(el.dataset.config);
  const { cities, jobs, targeturl } = elConfig;

  createWizard({
    el,
    name: 'Vacancies',
    template,
    async onSubmit({ data }) {
      console.log(data);

      const selectedCategories = data.job.jobs;
      const selectedLocations = [].concat(
        ...data.city.cities.map((val) => {
          return val.split('$$');
        })
      );

      console.log(selectedLocations, selectedCategories);

      sessionStorage.setItem(
        'jobfilter_selectedCategories',
        JSON.stringify(selectedCategories)
      );
      sessionStorage.setItem(
        'jobfilter_selectedLocations',
        JSON.stringify(selectedLocations)
      );

      window.location.assign(targeturl);
    },
    submitButtonLabel: 'Jobs anzeigen',
    additionalOptionSets: {
      cities,
      jobs,
    },
    initialData: {
      city: {
        cities: ['all'],
      },
      job: {
        jobs: ['all'],
      },
    },
  });
}

export default enable;
